import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent, getAnalytics as getFirebaseAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyA1zmXr12AjrAU-cEMPMHNFz3mGCCjBg5k",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "leaderpromed-ab6e1.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "leaderpromed-ab6e1",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "leaderpromed-ab6e1.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "286605251486",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:286605251486:web:394332510676c974547c8f",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-JVJL612Z4J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser)
let analytics;
if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}
export { analytics };

// Initialize services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// Collections constants
export const COLLECTIONS = {
  USERS: 'users',
  NEWS: 'news',
  LABORATORIES: 'laboratories',
  PRODUCTS: 'products',
  RESEARCH: 'research',
  GALLERY: 'gallery'
} as const;

// Analytics helper functions
export const getAnalyticsStats = async () => {
  try {
    // Pour obtenir les vraies statistiques, nous devons utiliser l'API Google Analytics
    // ou créer un endpoint backend qui récupère les données depuis Firebase Analytics
    
    // Option 1: Utiliser l'API Google Analytics (nécessite une configuration côté serveur)
    const response = await fetch('/api/analytics/stats', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (response.ok) {
      const data = await response.json();
      return {
        users: data.users || '--',
        pageViews: data.pageViews || '--',
        sessions: data.sessions || '--',
        bounceRate: data.bounceRate || '--'
      };
    }
    
    // Option 2: Fallback - utiliser des données simulées basées sur les événements locaux
    return getLocalAnalyticsStats();
    
  } catch (error) {
    console.error('Erreur lors de la récupération des stats Analytics:', error);
    return getLocalAnalyticsStats();
  }
};

// Fonction pour récupérer les statistiques locales (basées sur les événements Firebase Analytics)
const getLocalAnalyticsStats = () => {
  // Récupérer les données depuis localStorage ou sessionStorage
  const storedStats = localStorage.getItem('firebase_analytics_stats');
  
  if (storedStats) {
    try {
      const stats = JSON.parse(storedStats);
      return {
        users: stats.users || '--',
        pageViews: stats.pageViews || '--',
        sessions: stats.sessions || '--',
        bounceRate: stats.bounceRate || '--'
      };
    } catch (e) {
      console.error('Erreur parsing stats locales:', e);
    }
  }
  
  // Valeurs par défaut
  return {
    users: '--',
    pageViews: '--',
    sessions: '--',
    bounceRate: '--'
  };
};

// Fonction pour tracker les événements et mettre à jour les stats locales
export const trackPageView = (pageName: string) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_name: pageName,
      page_title: document.title
    });
    
    // Mettre à jour les stats locales
    updateLocalStats('pageViews');
  }
};

export const trackUserSession = () => {
  if (analytics) {
    logEvent(analytics, 'user_engagement', {
      engagement_time_msec: 1000
    });
    
    // Mettre à jour les stats locales
    updateLocalStats('sessions');
  }
};

// Fonction pour mettre à jour les statistiques locales
const updateLocalStats = (metric: string) => {
  try {
    const currentStats = getLocalAnalyticsStats();
    const currentValue = currentStats[metric as keyof typeof currentStats];
    
    let newValue = 1;
    if (currentValue !== '--') {
      newValue = parseInt(currentValue.toString()) + 1;
    }
    
    const updatedStats = {
      ...currentStats,
      [metric]: newValue
    };
    
    localStorage.setItem('firebase_analytics_stats', JSON.stringify(updatedStats));
  } catch (error) {
    console.error('Erreur mise à jour stats locales:', error);
  }
}; 